export default __webpack_public_path__ + "c9fe0ec77da3021eb696d9b47fc4db48.png";